// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"49ccb12c","223":"46b13aac","301":"c7018fe8","433":"a679f6bf","573":"f4633b34","830":"f2f777e1","968":"20acd95a"}[chunkId] + ".chunk.js";
};